import tags from "../../components/tags";
import { icons } from "../../components/html";
import { statusCodes } from "../../components/responses";

export default {
  "/size-charts": {
    get: {
      tags: [tags.sizeIdDatabase],
      summary: "List of available size charts",
      description: `${icons.c}
      Returns list of available size charts that are filtered by filter options.`,
      parameters: [
        { $ref: "#/components/parameters/acceptsLanguages" },
        { $ref: "#/components/parameters/brand" },
        { $ref: "#/components/parameters/type" },
        { $ref: "#/components/parameters/gender" },
        { $ref: "#/components/parameters/category" },
        { $ref: "#/components/parameters/limit" },
        { $ref: "#/components/parameters/offset" }
      ],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  id: {
                    type: "integer",
                    description: "Unique table identifier",
                    example: "1"
                  },
                  brand: {
                    type: "string",
                    description:
                      "Clothes brand for which the chart is displayed",
                    example: "Adidas"
                  },
                  type: {
                    type: "string",
                    description: "Kind of clothes - localized",
                    example: "Sportovní, vycházková obuv"
                  },
                  gender: {
                    $ref: "#/components/schemas/gender"
                  },
                  categories: {
                    type: "array",
                    items: {
                      $ref: "#/components/schemas/category"
                    }
                  },
                  labels: {
                    $ref: "#/components/schemas/tableMarking"
                  }
                }
              }
            }
          }
        },
        ...statusCodes
      }
    }
  }
};
